<template>
  <b-card-code title="Ajout d'une nouvelle filière">
    <b-card-text>
      <span>Veuillez saisir les coordonnées du filière </span>
    </b-card-text>

    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Année Univ"
              label-for="Année Univ"
            >
              <validation-provider
                #default="{ errors }"
                name="Année Univ"
                rules="required"
              >
                <b-form-input
                  v-model="filieres.academic_year"
                  :state="errors.length > 0 ? false : null"
                  disabled
                  placeholder="Année Univ"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Diplôme"
              label-for="Diplôme"
            >
              <validation-provider
                #default="{ errors }"
                name="Diplôme"
                rules="required"
              >
                <v-select
                  v-model="filieres.diploma"
                  :clearable="false"
                  :options="diplomas"
                  label="name"
                  placeholder="Diplôme"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Département"
              label-for="Département"
            >
              <validation-provider
                #default="{ errors }"
                name="Département"
                rules="required"
              >
                <v-select
                  v-model="filieres.department"
                  :clearable="false"
                  :options="departements"
                  label="name"
                  placeholder="Département"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Libellé Abrégé"
              label-for="Libellé Abrégé"
            >
              <validation-provider
                #default="{ errors }"
                name="Libellé Abrégé"
                rules="required"
              >
                <b-form-input
                  v-model="filieres.abbreviated_label"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Libellé Abrégé"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Libellé"
              label-for="Libellé"
            >
              <validation-provider
                #default="{ errors }"
                name="Libellé"
                rules="required"
              >
                <b-form-input
                  v-model="filieres.label"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Libellé"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Libellé en Arabe"
              label-for="Libellé en Arabe"
            >
              <validation-provider
                #default="{ errors }"
                name="Libellé en Arabe"
                rules="required"
              >
                <b-form-input
                  v-model="filieres.label_arabe"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Libellé en Arabe"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <h5>Active</h5>
              <b-form-checkbox
                v-model="filieres.is_active"
                name="check-button"
                switch
                inline
                @click="filieres.is_active = true"
              >
                Active
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <h5>Admet Parcous</h5>
              <b-form-checkbox
                v-model="filieres.admits_course"
                name="check-button"
                switch
                inline
                @click="filieres.admits_course = true"
              >
                Admet Parcous
              </b-form-checkbox>
            </b-form-group>

          </b-col>
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              @click.prevent="addfiliere"
            >
              Ajouter
            </b-button>
            <b-button
              variant="outline-secondary"
              type="reset"
            >
              Réinitialiser
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormCheckbox,
  BCardText /*  */,
} from 'bootstrap-vue'
import { required } from '@validations'
import storeAuth from '@/store/store'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    /* BFormTextarea, */
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormCheckbox,

  },
  data() {
    return {
      password: '',

      filieres: {
        academic_year_id: '',
        abbreviated_label: '',
        label: '',
        label_arabe: '',
        diploma: '',
        department: '',
        is_active: false,
        admits_course: false,
      },
      required,
      departements: [],
      diplomas: [],
    }
  },
  created() {
    this.getDepartements()
    this.getDiplomas()
    this.filieres.academic_year = storeAuth.state.currentAcademicYear.academic_year
    this.filieres.academic_year_id = storeAuth.state.currentAcademicYear.id
  },
  methods: {
    async getDiplomas() {
      this.load = 'true'
      const response = await axios.get('/api/diplomas/')
      this.diplomas = response.data
      this.load = 'false'
    },
    async getDepartements() {
      this.load = 'true'
      const response = await axios.get('/api/departments/')
      this.departements = response.data
      this.load = 'false'
    },
    async addfiliere() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          try {
            await axios
              .post(
                '/api/filieres/create/',
                {
                  abbreviated_label: this.filieres.abbreviated_label,
                  label: this.filieres.label,
                  label_arabe: this.filieres.label_arabe,
                  diploma: this.filieres.diploma.id,
                  department: this.filieres.department.id,
                  admits_course: this.filieres.admits_course,
                  academic_year: this.filieres.academic_year_id,
                  is_active: this.filieres.is_active,
                },
              )
            this.$router.push('/filieres')
            setTimeout(() => {
              this.showToast('success', 'top-center', 'Filiere ajouté avec succés')
            }, 1000)
          } catch (err) {
            setTimeout(() => {
              this.showToast('danger', 'top-center', err.toString())
            }, 1000)
          }
        }
      })
    },

    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
